/* eslint-disable @typescript-eslint/no-explicit-any */
// Notificaciones (iNotifications) contra el GraphQL de masterws. Usa variables, no texto pegado en la query.
import * as url from './url_helper';

const gql = async (query: string, variables: any = {}) => {
  const r = await fetch(url.API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  }).then((x) => x.json());
  if (r?.errors?.length) throw new Error(r.errors[0].message);
  return r?.data || {};
};

export const getNotifications = async ({ pagination, filters, order }: any) => {
  const f: any = {
    initial_date: filters.from || null,
    final_date: filters.to || null,
    order,
    action: filters.action || null,
    status: filters.status || null,
    search: filters.search || null,
  };
  if (filters.clientId) f.clientId = Number(filters.clientId);
  if (filters.fallback === 'yes') f.fallback = true;
  if (filters.fallback === 'no') f.fallback = false;
  const data = await gql(
    `query ($filters: INotificationsFiltersInput, $p: INotificationsPagination!) {
      GetNotifications(filters: $filters, Pagination: $p) {
        CountItems
        listData { id clientId clientName taskId number action fromAddress via fallback toAddresses subject status error sentAt createdAt }
      }
    }`,
    { filters: f, p: { sizePage: pagination.sizePerPage, actualPage: pagination.page } },
  );
  return data.GetNotifications || { listData: [], CountItems: 0 };
};

export const getNotificationFilters = async () => {
  const data = await gql(`query { GetNotificationFilters { clients { id name } actions } }`);
  return data.GetNotificationFilters || { clients: [], actions: [] };
};

export const getNotificationHtml = async (id: number) => {
  const data = await gql(`query ($id: Int!) { GetNotificationHtml(id: $id) }`, { id });
  return data.GetNotificationHtml || null;
};
